import { IRoute } from 'interfaces'

export enum AdminRouteName {
    tableService = 'tableService',
    quickService = 'quickService',
    totalSaleDashboard = 'totalSaleDashboard',
    onlineOrder = 'onlineOrder',
    //Report
    orderDashboard = 'orderDashboard',
    closeOfDay = 'closeOfDay',
    salesReport = 'salesReport',
    terminalReport = 'terminalReport',
    accountReport = 'accountReport',
    settingReport = 'settingReport',
    //online
    onlineStore = 'onlineStore',
    onlineMenuBuilder = 'onlineMenuBuilder',
    onlineIntegrations = 'onlineIntegrations',
    //product
    productCategory = 'productCategory',
    product = 'product',
    combo = 'combo',
    ingredient = 'ingredient',
    vendor = 'vendor',
    //inventory
    inventory = 'inventory',
    inventoryReport = 'inventoryReport',
    uoms = 'unitOfMeasure',
    //pos
    posGeneral = 'posGeneral',
    posMenu = 'posMenu',
    posSaleProcessing = 'posSaleProcessing',
    posCondition = 'posCondition',
    tableLayout = 'tableLayout',
    receiptSetting = 'receiptSetting',
    //device
    terminalDevice = 'terminalDevice',
    printerDevice = 'printerDevice',
    hardwareAgents = 'hardwareAgents',
    integrationDevice = 'integrationDevice',
    //finacial
    financialGeneral = 'financialGeneral',
    paymentMethod = 'paymentMethod',
    taxes = 'taxes',
    priceList = 'priceList',
    //promotion
    discount = 'discount',
    giftCard = 'giftCard',
    //employee
    users = 'users',
    employeeTimeClock = 'employeeTimeClock',
    employeeReport = 'employeeReport',
    //customers
    customers = 'customers',
    customerCategory = 'customerCategory',
    customerLoyalty = 'customerLoyalty',
    //setting
    locationSetting = 'locationSetting',
    companySetting = 'companySetting',

    // setup = 'setup',
    // batch = 'batch',
    //current user setting
    terminalPreference = 'terminalPreference',
    myAccount = 'myAccount',
    userPreference = 'userPreference',
}
interface IAdminRoute extends IRoute {
    tabsPermission?: {
        [routeName in tabNames]?: number[]
    }
}
export type IRouteConstant = {
    [routeName in AdminRouteName]: IAdminRoute
}
export enum tabNames {
    //employees tabs
    users = 'users',
    roles = 'roles',
    notificationGroup = 'notification_group',
    employeeTimeclock = 'employee_timeclock',
    employeeReport = 'employee_report',
    //pos tabs
    posGeneral = 'pos_general',
    tsRule = 'ts_rule',
    qsRule = 'qs_rule',
    onlineRule = 'online_rule',
    posServiceCharge = 'pos_servicecharge',
    voidCompReason = 'void_comp_reason',
    tableLayout = 'table_layout',
    menu = 'menu',
    menuViews = 'menu_views',
    saleProcess = 'sale_process',
    payInOutReasons = 'pay_in_out_reasons',
    orderNumber = 'order_number',
    //company-setting tabs
    location = 'location',
    companyBrand = 'brand',
    subscription = 'subscription',
    companyProfile = 'profile',
    //location-setting tabs
    locationGeneral = 'location_general',
    orderChannel = 'order_channel',
    fulfillmentOptions = 'fulfillment_options',
    locationBrand = 'location_brand',
    //inventory report tab
    inventoryReport = 'inventory_report',
    cogsReport = 'cogs_report',
    //Z Close day
    closeOfDay = 'close_of_day',
    closeOfDayHistory = 'close_of_day_history',
    //online store
    onlineMyStore = 'online_my_store',
    onlineOrderChannelStore = 'online_order_channel_store',
    //product Tab
    products = 'products',
    category = 'category',
    variant = 'variant',
    modifier = 'modifier',
    combo = 'combo',
    giftcards = 'giftcards',
    setupGiftcard = 'setup_giftcard',
    ingredient = 'ingredient',
    //receipt tab
    receiptSetting = 'receipt_setting',
    reportSetting = 'report_setting',
    codSetting = 'cod_setting',
    //financial
    financialGeneral = 'financial_general',
    companyDetails = 'company_details',
    taxes = 'taxes',
    accountCodes = 'account_codes',
    financialPayments = 'financial_payments',
    posPayment = 'pos_payment',
    accounts = 'accounts',
    orderEvent = 'orderEvent',
    paymentIntegration = 'payment_integration',
}
